/**
 * Повторяющиеся тексты интерфейса.
 * Тон: спокойный, на «вы», без канцелярита. ГОСТ — только в документации.
 */
export const uiCopy = {
    errorTitle: 'Не получилось',
    loadFailed: 'Не получилось загрузить данные. Попробуйте ещё раз.',
    actionFailed: 'Не получилось выполнить действие. Попробуйте ещё раз.',
    retry: 'Повторить',
    crmDownTitle: 'CRM сейчас не отвечает',
    crmDownHint: 'Этот блок временно недоступен. Обновите страницу чуть позже.',
    sectionLoadFailed: 'Не получилось открыть этот блок. Попробуйте ещё раз.',
    agentScopeOwnEmptyTitle: 'Моих агентов пока нет',
    agentScopeOwnEmptyHint: 'Когда агенты появятся в вашей сети, они будут здесь.',
    agentScopeOwnAndFreeEmptyTitle: 'Свободных агентов пока нет',
    agentScopeOwnAndFreeEmptyHint: 'Свободные — агенты без текущего закрепления. Когда такие появятся, они будут здесь.',
    agentScopeAllEmptyTitle: 'Агентов пока нет',
    agentScopeAllEmptyHint: 'В справочнике пока нет агентов.',
    brandManagersEmptyTitle: 'Справочник пока пуст',
    brandManagersEmptyHint: 'Когда в CRM появятся бренд-менеджеры, они будут здесь.',
    brandManagerSearch: 'Найти по имени',
    pickBrandManager: 'За кем закрепить',
    pickBmAssignment: 'Кому назначить',
    pickFreeAgent: 'Кого закрепить',
    pickAgent: 'Кого закрепить',
    assignAction: 'Закрепить',
    transferAction: 'Передать',
    assignToBmAction: 'Закрепить за БМ',
    transferToBmAction: 'Передать другому БМ',
    assignBmAction: 'Назначить бренд-менеджера',
    changeBmAction: 'Сменить бренд-менеджера',
    bmAssignmentNone: 'Бренд-менеджер не назначен',
    openAgentCard: 'Открыть карточку',
    queuesBmFilterAll: 'Все',
    queuesBmFilterUnassigned: 'Без БМ',
    queuesBmFilterLabel: 'Назначение бренд-менеджера',
    currentManagerBadge: 'Вы',
    agentChatTitle: 'Чат с агентом',
    agentChatNewTab: 'Новый чат',
    agentChatCloseTab: 'Закрыть чат',
    agentChatPlaceholder: 'Напишите сообщение агенту',
    agentChatAgentMode: 'Агент',
    agentChatModelOffline: 'Не подключена',
    agentChatModelPending: 'Отвечает…',
    agentChatAttachMd: 'Приложить Markdown',
    agentChatRemoveAttachment: 'Убрать файл',
    agentChatSend: 'Отправить',
    agentChatVoiceUnavailable: 'Голосовой ввод пока недоступен',
    agentChatEmpty: 'Напишите сообщение — оно останется в этой вкладке.',
    agentChatUserLabel: 'Вы',
    agentChatAssistantLabel: 'Агент',
    agentChatProactiveBadge: 'Расшифровка',
    agentChatActionDone: 'Готово',
    agentChatActionPending: 'Выполняется…',
    agentChatResize: 'Изменить ширину чата',
    agentChatPending: 'Агент готовит ответ…',
    agentChatErrorFallback: 'Не удалось получить ответ агента. Попробуйте ещё раз.',
    fixationActive: 'Активна',
    fixationEnding: 'Заканчивается',
    fixationNone: 'Нет фиксации',
    fixationLabel: 'Фиксация',
    fixationUntil: 'до',
    brandManagerLabel: 'Бренд-менеджер',
    agentBlockedBadge: 'В блоке',
    topAgentBadge: 'Топ агент',
    copyPhone: 'Скопировать телефон',
    phoneCopied: 'Скопировано',
    openTelegram: 'Открыть Telegram',
    backToAgents: 'К списку агентов',
    agentCardPermanentHint: 'Постоянная карточка Агента',
    agentCardNoActiveEngagement: 'Без активного Вовлечения',
    agentCardActiveEngagement: 'Активное вовлечение',
    agentCardContactsTitle: 'Контактные данные',
    agentCardContactsEdit: 'Редактировать',
    agentCardPhone: 'Телефон',
    agentCardBirthDate: 'Дата рождения',
    agentCardAgency: 'Агентство',
    agentCardCrmAssignment: 'Закрепление в ЦРМ',
    agentCardSocials: 'Социальные сети',
    agentCardNotSpecifiedF: 'Не указана',
    agentCardNotSpecifiedN: 'Не указано',
    agentCardNotAssigned: 'Не закреплён',
    agentCardSocialsEmpty: 'Не указаны',
    agentCardRatingsTitle: 'Рейтинги',
    agentCardRatingAgent: 'Рейтинг Агента · всё время',
    agentCardRatingEngagement: 'Рейтинг Вовлечения',
    agentCardRatingExternal: 'Внешний рейтинг',
    externalRatingPick: 'Выберите балл',
    externalRatingUnset: 'Не задан',
    externalRatingSaved: 'Внешний рейтинг сохранён',
    externalRatingRequired: 'Выберите внешний рейтинг',
    agentCardRatingProof: 'Проверить начисления',
    agentCardRatingBreakdown: 'Из чего сложился рейтинг',
    agentCardRatingBreakdownHide: 'Скрыть расшифровку',
    agentCardContractTitle: 'Договор с АН',
    agentCardContractFill: 'Заполнить АН',
    agentCardContractOpen: 'Открыть АН',
    agentCardContractHint: 'Укажите АН в карточке Агента.',
    agentCardStreamEmptyTitle: 'Активного Вовлечения нет',
    agentCardStreamEmptyHint: 'Создайте Вовлечение, чтобы отслеживать новые события Агента. События завершённых периодов доступны в соответствующих Вовлечениях.',
    agentCardOpenActiveEngagement: 'Активное вовлечение',
    fillQuestionnaire: 'Заполнить анкету',
    openQuestionnaire: 'Открыть анкету',
    nextStepTitle: 'Следующий шаг к продаже',
    nextStepWaitingBadge: 'Ожидание',
    nextStepActionBadge: 'Действие',
    nextStepBtInvite: 'Агент ещё не приглашён на брокер-тур. Пригласите агента на БТ.',
    nextStepBtConduct: 'Брокер-тур запланирован. Проведите БТ.',
    nextStepBtAwaitNotice: 'Агент был на БТ и ещё не направил уведомление. Дождитесь уведомления от агента.',
    nextStepBusTour: 'Агент ещё не видел квартиры на туре. Пригласите на автобусный тур.',
    nextStepProjectAttendance: 'Агент ещё мало видел проекты. Откройте матрицу посещенности и пригласите на объекты.',
    nextStepMeeting: 'Агент ещё не привёл клиента на встречу. Назначьте следующий контакт.',
    nextStepAgencyContract: 'Агентство ещё не продаёт квартиры системно. Двигайте договор с АН.',
    nextStepQuestionnaire: 'Мало данных об агенте. Заполните анкету, чтобы говорить предметно.',
    nextStepDone: 'Путь к продаже закрыт по шкалам. Поддерживайте контакт и смотрите признаки продаж.',
    openTasksTitle: 'Задачи по агенту',
    openTasksEmpty: 'нет открытых',
    openTasksCount: 'открытых',
    openTasksLink: 'Все задачи',
    agencyShortLabel: 'АН',
    engagementStartedAt: 'Дата начала',
    engagementNumber: 'Номер',
    engagementResponsibleUnassigned: 'Не закреплён',
    engagementResponsible: 'Ответственный',
    engagementStatus: 'Статус',
    engagementStatusActive: 'Активно',
    engagementStatusClosed: 'Закрыто',
    engagementResponsibleCrmSync: 'Синхронизация CRM',
    engagementTrackNotStarted: 'Не начато',
    engagementTrackPending: 'Скоро: данные появятся позже',
    engagementTrackBoard: 'Доска',
    questionnaireEmptyFields: 'Не заполнено',
    questionnaireEmptyFieldsUnit: 'полей',
    questionnaireEmptyFieldsUnitOne: 'поле',
    questionnaireEmptyFieldsUnitFew: 'поля',
    salesSignalsTitle: 'Признаки продажи',
    salesSignalsEmpty: 'Продаж и встреч по нашим квартирам пока нет.',
    salesSignalsLastFeedback: 'Последняя обратная связь',
    salesSignalsLastVisit: 'Последний визит',
    salesSignalsFeedbackLink: 'Обратная связь',
    profileTitle: 'Профиль',
    profileBotTelegram: 'Бот Telegram',
    profileBotTelegramLinked: 'Подключён',
    profileBotTelegramMissing: 'Нет',
    telegramDataTitle: 'Данные из Telegram',
    telegramDataStatus: 'Статус',
    telegramDataLookedUpAt: 'Проверено',
    telegramDataUsername: 'Аккаунт',
    telegramDataBio: 'О себе',
    telegramDataChannel: 'Личный канал',
    telegramDataChannelMembers: 'подписчиков',
    telegramDataInstagram: 'Instagram',
    telegramDataVk: 'ВКонтакте',
    telegramDataWebsites: 'Сайты',
    telegramDataOtherSocials: 'Другие ссылки',
    telegramDataRefresh: 'Обновить из Telegram',
    telegramDataRefreshing: 'Ищем аккаунт в Telegram…',
    telegramDataEmpty: 'Данных пока нет. Нажмите «Обновить из Telegram».',
    telegramDataUnavailable: 'Сервис Telegram недоступен',
    telegramStatusFound: 'Найден',
    telegramStatusNotFound: 'Не найден',
    telegramStatusPending: 'Ещё не искали',
    telegramStatusPrivacyRestricted: 'Скрыт настройками приватности',
    telegramStatusInvalidPhone: 'Нет телефона для поиска',
    telegramStatusFloodWait: 'Лимит Telegram, повторите позже',
    telegramStatusError: 'Ошибка поиска',
    telegramStatusUnavailable: 'Сервис недоступен',
    questionnaireTitle: 'Анкета БМ',
    questionnaireEmpty: 'Анкета ещё не заполнена.',
    questionnaireFilled: 'Заполнено',
    agentCardTabQuestionnaire: 'Анкета от БМ',
    agentCardTabLeads: 'Заявки',
    agentCardTabTouchpoints: 'Касания',
    agentCardTabRating: 'Рейтинг',
    agentCardQuestionnaireProgress: 'Заполнение анкеты',
    agentCardQuestionnaireEditYandex: 'Редактировать на Яндекс.Формах',
    agentCardLeadsInWork: 'В работе',
    agentCardLeadsEmpty: 'Заявок пока нет.',
    agentCardLeadsShow: 'Показывать',
    agentCardLeadsPage: 'Страница',
    agentCardLeadsOf: 'из',
    agentCardTouchMeetings: 'Встречи',
    agentCardTouchMeetingsEmpty: 'Встреч с участием агента не найдено',
    agentCardTouchHeldMark: 'Отметка о проведении',
    agentCardTouchLastVisits: 'Последние визиты',
    agentCardTouchLastVisitsEmpty: 'Записи не найдены',
    agentCardRatingEmpty: 'Нет данных',
    agentCardRatingParam: 'Параметр',
    agentCardRatingQuantity: 'Кол-во',
    agentCardRatingPoints: 'Баллы',
    timelineTitle: 'Ось времени',
    timelineEmpty: 'Активностей пока нет.',
    engagementTitle: 'Вовлечение',
    createEngagement: 'Создать вовлечение',
    engagementTableSearch: 'Найти по ФИО или БМ',
    engagementTableSearchLabel: 'Поиск в шаге',
    engagementBoardSearchLabel: 'Поиск на доске',
    engagementDragHandle: 'Перетащить на следующий шаг',
    engagementTableSortAsc: 'по возрастанию',
    engagementTableSortDesc: 'по убыванию',
    engagementTableNoMatches: 'Никого не нашли по этому запросу.',
    agentListSearchLabel: 'Поиск Агентов',
    agentListSearch: 'ФИО, любой телефон, агентство',
    agentListIntro: 'Агенты ЦРМ и приоритетного списка, включая тех, у кого пока нет Вовлечения.',
    agentListIntroHint: 'Без объединения исходных карточек',
    agentListAddAgent: 'Добавить Агента',
    agentListColAgent: 'Агент',
    agentListColAgency: 'Агентство',
    agentListColRatingAgent: 'РА',
    agentListColRatingEngagement: 'РВ',
    agentListColRatingExternal: 'ВР',
    agentListColCompleteness: 'Заполненность',
    agentListColContract: 'Договор с АН',
    agentListColEngagements: 'Вовлечения',
    agentListRatingAgentTitle: 'Рейтинг Агента за всё время',
    agentListRatingEngagementTitle: 'Рейтинг активного Вовлечения',
    agentListRatingExternalTitle: 'Внешний рейтинг',
    agentListAgencyUnset: 'Не указано',
    agentListFillAgency: 'Заполнить АН',
    agentListOpenAgency: 'Открыть АН',
    agentListNoActiveEngagements: 'Нет активных',
    agentListActiveEngagementOne: '1 активное',
    agentListActiveEngagementMany: '{n} активных',
    agentListEngagementTotal: 'Всего: {n}',
    agentListEmptyCell: '—',
    agentListPartialHint: 'Поиск идёт по загруженной части списка. Показано {loaded} из {total}.',
    agentListRangeCount: 'Показано {from}–{to} из {total}.',
    agentListPageLabel: 'Страница {page} из {pages}.',
    agentListPrevPage: 'Назад',
    agentListNextPage: 'Дальше',
    agentCreateTitle: 'Новый Агент',
    agentCreateSubtitle: 'Постоянная карточка партнёра',
    agentCreateNote: 'Контакты и сведения Агента общие для всех его Вовлечений.',
    agentCreateFullName: 'ФИО',
    agentCreatePhone: 'Телефон',
    agentCreateAgency: 'Агентство',
    agentCreateSubmit: 'Сохранить Агента',
    agentCreateCancel: 'Отмена',
    agentCreateExistsTitle: 'Агент с таким телефоном уже есть',
    agentCreateOpenExisting: 'Открыть карточку',
};
export function agentScopeEmptyCopy(scope) {
    if (scope === 'ownAndFree') {
        return {
            title: uiCopy.agentScopeOwnAndFreeEmptyTitle,
            hint: uiCopy.agentScopeOwnAndFreeEmptyHint,
        };
    }
    if (scope === 'all') {
        return {
            title: uiCopy.agentScopeAllEmptyTitle,
            hint: uiCopy.agentScopeAllEmptyHint,
        };
    }
    return {
        title: uiCopy.agentScopeOwnEmptyTitle,
        hint: uiCopy.agentScopeOwnEmptyHint,
    };
}
export function feedbackKindLabel(kind) {
    if (kind === 'BOOKING_CANCELED')
        return 'Слетела бронь';
    if (kind === 'TRADE_IN_EVALUATION')
        return 'Трейд-ин';
    return kind;
}
export function agentCountLabel(count) {
    const abs = Math.abs(count) % 100;
    const last = abs % 10;
    if (abs > 10 && abs < 20)
        return `${count} агентов`;
    if (last === 1)
        return `${count} агент`;
    if (last >= 2 && last <= 4)
        return `${count} агента`;
    return `${count} агентов`;
}
export function taskStatusLabel(status) {
    if (status === 'OPEN')
        return 'Открыта';
    if (status === 'IN_PROGRESS')
        return 'В работе';
    if (status === 'DONE')
        return 'Готово';
    return status;
}
export function transcriptionStatusLabel(status) {
    if (status === 'ready')
        return 'Готова';
    if (status === 'queued')
        return 'В очереди';
    if (status === 'processing')
        return 'Расшифровываем';
    if (status === 'failed')
        return 'Ошибка';
    if (status === 'cancelled')
        return 'Отменена';
    return status;
}
export function fixationStatusLabel(status) {
    if (status === 'ACTIVE')
        return uiCopy.fixationActive;
    if (status === 'ENDING')
        return uiCopy.fixationEnding;
    return uiCopy.fixationNone;
}
export function engagementStatusLabel(status) {
    if (status === 'ACTIVE')
        return uiCopy.engagementStatusActive;
    if (status === 'CLOSED')
        return uiCopy.engagementStatusClosed;
    return status;
}
export function engagementResponsibleLabel(value) {
    if (!value.trim())
        return uiCopy.engagementResponsibleUnassigned;
    if (value === 'crm-sync' || value === 'CRM_SYNC') {
        return uiCopy.engagementResponsibleCrmSync;
    }
    return value;
}
export function emptyFieldsCountLabel(count) {
    const abs = Math.abs(count) % 100;
    const last = abs % 10;
    let unit = uiCopy.questionnaireEmptyFieldsUnit;
    if (!(abs > 10 && abs < 20)) {
        if (last === 1)
            unit = uiCopy.questionnaireEmptyFieldsUnitOne;
        else if (last >= 2 && last <= 4)
            unit = uiCopy.questionnaireEmptyFieldsUnitFew;
    }
    return `${uiCopy.questionnaireEmptyFields}: ${count} ${unit}`;
}
